import { render, staticRenderFns } from "./LastBookingsCard.vue?vue&type=template&id=b8f27e9c&scoped=true&"
import script from "./LastBookingsCard.vue?vue&type=script&lang=js&"
export * from "./LastBookingsCard.vue?vue&type=script&lang=js&"
import style0 from "./LastBookingsCard.vue?vue&type=style&index=0&id=b8f27e9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f27e9c",
  null
  
)

export default component.exports